// extracted by mini-css-extract-plugin
export default {"ipt":"index_ipt_OsAX1","bar":"index_bar_97vf-"};